export const MockActions = {


    get: (path, callback) => {

        if (mocks[path]) {
            callback(mocks[path])

            return true;
        }

        if (path === "/production/3/series") {
            callback(series);

            return true;
        } else {
            return false;
        }
    },

};

export const series = [

    {
        releaseDate: "23-03-2003",
        user: "test",
        finished: false,
        performanceExceeded: true,
        comment: "Basdasdsadas"
    },


]

export const mocks = {
    // "line": [
    //     {
    //         id: "1",
    //         internalNumber: "INT-001",
    //         name: "MARCHESINI II",
    //         packingSystem: "ALU/ALU"
    //     }
    //
    // ],
    "line/123232":
        {
            id: "1",
            creationUsername: "system",
            creationDate: "13-06-2024",
            internalNumber: "INT-001",
            name: "MARCHESINI I",
            packingSystem: "ALU/ALU",
            room: "3/21_PAKOWNIA MARCHESINI I",
            commonImages: [
                {
                    fileName: "commonImage1.jpg"
                }
            ],
            machines: [
                {
                    id: 1,
                    type: "BLISTERING",
                    model: "MB421",
                    serialNumber: "34094",
                    productionYear: "2004",
                    images: [
                        {
                            fileName: "Tabliczka znamionowa.jpg",
                        }
                        , {
                            fileName: "Zdjęcie nr. 1 .jpg",
                        }
                    ],
                    parentLine: {
                        name: ""
                    },
                    formatPartsCategories: [
                        {
                            category: {
                                id: 1,
                                name: "PVC",
                                label: null
                            },
                            formatParts: [
                                {
                                    name: "Płyta formująca górna",
                                    files: []
                                },
                                {
                                    name: "Płyta formująca dolna",
                                    files: []
                                },
                            ]
                        },
                        {
                            category: {
                                id: 2,
                                name: "AL/AL",
                                label: null
                            },
                            formatParts: [
                                {
                                    name: "Płyta formująca",
                                    files: []
                                },
                                {
                                    name: "Czujnik mikropęknięć",
                                    files: []
                                },
                            ]
                        },
                        {
                            category: {
                                id: 3,
                                name: "ELEMENTY FORMATOWE WSPÓLNE",
                                label: null
                            },
                            formatParts: [
                                {
                                    name: "Wałek mocujący folię",
                                    files: []
                                },
                                {
                                    name: "Prowadnica długa",
                                    files: []
                                },
                                {
                                    name: "Listwy pokrywające (komplet)",
                                    files: []
                                },
                                {
                                    name: "Szyba kontrastowa (kamera tabletek)",
                                    files: []
                                },
                                {
                                    name: "Bęben zgrzewający",
                                    files: []
                                },
                                {
                                    name: "Dystans rolki bębna zgrzewającego",
                                    files: []
                                },
                                {
                                    name: "Datownik",
                                    files: []
                                },
                                {
                                    name: "Odbojnik datownika",
                                    files: []
                                },
                                {
                                    name: "Perforacja",
                                    files: []
                                },
                                {
                                    name: "Prowadnica krótka",
                                    files: []
                                },
                                {
                                    name: "Prowadnica podciągania",
                                    files: []
                                },
                                {
                                    name: "Listwy stabilizujące folię",
                                    files: []
                                },
                                {
                                    name: "Listwa stabilizująca przed wykrojnikiem",
                                    files: []
                                },
                                {
                                    name: "Wykrojnik",
                                    files: []
                                },
                                {
                                    name: "Ssawki blistra",
                                    files: []
                                }
                            ]
                        },
                        {
                            category: {
                                id: 4,
                                name: "ZASYP TABLETEK",
                                label: "simtap"
                            },
                            formatParts: [
                                {
                                    name: "Mocowanie Simtapa",
                                    files: []
                                },
                                {
                                    name: "Sterowanie powietrzem Simtapa",
                                    files: []
                                },
                                {
                                    name: "Trzpień mocujący wibracje",
                                    files: []
                                },
                                {
                                    name: "Wibracja",
                                    files: []
                                },
                                {
                                    name: "Prowadnice sita",
                                    files: []
                                },
                                {
                                    name: "Sito",
                                    files: []
                                },
                                {
                                    name: "Podstawa zasypu",
                                    files: []
                                },
                                {
                                    name: "Zasobnik tabletek",
                                    files: []
                                },
                                {
                                    name: "Pokrywa zasypowa",
                                    files: []
                                },
                                {
                                    name: "Zasobnik tabletek",
                                    files: []
                                },
                                {
                                    name: "Pokrywa zasypowa",
                                    files: []
                                },
                                {
                                    name: "Pojemnik odpadów",
                                    files: []
                                },
                                {
                                    name: "Sito odpadów",
                                    files: []
                                },
                                {
                                    name: "Rozdzielacz tabletek",
                                    files: []
                                },
                                {
                                    name: "Pokrywa sita",
                                    files: []
                                },
                                {
                                    name: "Pokrywa Simtapa",
                                    files: []
                                },
                                {
                                    name: "Mocowanie węży Simtapa (komplet)",
                                    files: []
                                },
                                {
                                    name: "Węże Simtapa",
                                    files: []
                                },
                                {
                                    name: "Simtap",
                                    files: []
                                },
                                {
                                    name: "Szczotka układająca",
                                    files: []
                                }
                            ]
                        },
                        {
                            category: {
                                id: 5,
                                name: "ZASYP TABLETEK",
                                label: "szczotkowy"
                            },
                            formatParts: [
                                {
                                    name: "Szczotki",
                                    files: []
                                },
                                {
                                    name: "Trzpień mocujący wibracje",
                                    files: []
                                },
                                {
                                    name: "Wibracja",
                                    files: []
                                },
                                {
                                    name: "Prowadnice sita",
                                    files: []
                                },
                                {
                                    name: "Sito",
                                    files: []
                                },
                                {
                                    name: "Podstawa zasypu",
                                    files: []
                                },
                                {
                                    name: "Zasobnik tabletek",
                                    files: []
                                },
                                {
                                    name: "Pokrywa zasypowa",
                                    files: []
                                },
                                {
                                    name: "Pojemnik odpadów",
                                    files: []
                                },
                                {
                                    name: "Sito odpadów",
                                    files: []
                                },
                                {
                                    name: "Pokrywa sita",
                                    files: []
                                },
                                {
                                    name: "Rozdzielacz tabletek",
                                    files: []
                                },
                                {
                                    name: "Węże podajnika",
                                    files: []
                                },
                                {
                                    name: "Mocowanie węży Podajnika (komplet)",
                                    files: []
                                }
                            ]
                        }
                    ]
                },
                {
                    id: 2,
                    type: "CARTON",
                    model: "C 2305",
                    serialNumber: "13306610",
                    productionYear: "2022",
                    images: [
                        {
                            fileName: "Tabliczka znamionowa.jpg"
                        }
                    ],
                    formatPartsCategories: [
                        {
                            category: {
                                id: 6,
                                name: "ELEMENTY FORMATOWE",
                                label: null
                            },
                            formatParts: [
                                {
                                    name: "Łapka magazynka",
                                    files: []
                                },
                                {
                                    name: "Talerzyki magazynków",
                                    files: []
                                },
                                {
                                    name: "Bandy prowadzące",
                                    files: []
                                },
                                {
                                    name: "Banda popychacza",
                                    files: []
                                },
                                {
                                    name: "Popychacz",
                                    files: []
                                },
                                {
                                    name: "Kontrpopychacz",
                                    files: []
                                },
                                {
                                    name: "Ramiona ssące",
                                    files: []
                                },
                                {
                                    name: "Blaszka prowadzenia skrzydełek",
                                    files: []
                                },
                                {
                                    name: "Zamykanie kartonika",
                                    files: []
                                },
                                {
                                    name: "Mechanizm kierunku zamykania",
                                    files: []
                                }
                            ]

                        },
                    ]
                },
                {
                    id: 3,
                    type: "SELECTOR",
                    model: "DWM 750 HP",
                    serialNumber: "736415/22",
                    images: [
                        {
                            fileName: "Tabliczka znamionowa.jpg"
                        }
                    ],
                    formatPartsCategories: [
                        {
                            category: {
                                id: 7,
                                name: "ELEMENTY FORMATOWE",
                                label: null
                            },
                            formatParts: [
                                {
                                    name: "Element odwracania",
                                    files: []
                                },
                                {
                                    name: "Popychacz pionowy",
                                    files: []
                                },
                                {
                                    name: "Popychacz poziomy",
                                    files: []
                                },
                                {
                                    name: "Bandy wyjściowe",
                                    files: []
                                }
                            ]

                        },
                    ]

                },
                {
                    id: 4,
                    type: "ANTARES",
                    model: "AV7509_PRINT&CHECK ADVANCED",
                    serialNumber: "201803.7509.001",
                    productionYear: "2022",
                    images: [
                        {
                            fileName: "Tabliczka znamionowa.jpg"
                        }
                    ],
                    formatPartsCategories: []
                },
                {
                    id: 5,
                    type: "COMMON_CARTON",
                    model: "CARTONATRICE_PS 300",
                    serialNumber: "L8060013",
                    productionYear: "2006",
                    images: [
                        {
                            fileName: "Tabliczka znamionowa.jpg"
                        }
                    ],
                    formatPartsCategories: []
                }
            ]
        },
    "line/123232/formatParts":
        [
            {
                name: "Płyta formująca górna",
                category: "PVC",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Płyta formująca dolna",
                category: "PVC",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Płyta formująca",
                category: "AL/AL",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Czujnik mikropęknięć",
                category: "AL/AL",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Wałek mocujący folię",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Prowadnica długa",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Listwy pokrywające (komplet)",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Szyba kontrastowa (kamera tabletek)",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Bęben zgrzewający",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Dystans rolki bębna zgrzewającego",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Datownik",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Odbojnik datownika",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Perforacja",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Prowadnica krótka",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Prowadnica podciągania",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Listwy stabilizujące folię",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Listwa stabilizująca przed wykrojnikiem",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Wykrojnik",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Ssawki blistra",
                category: "ELEMENTY FORMATOWE WSPÓLNE",
                machine: "BLISTERING MB421 34094 2004",
                label: null
            },
            {
                name: "Mocowanie Simtapa",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Sterowanie powietrzem Simtapa",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Trzpień mocujący wibracje",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Wibracja",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Prowadnice sita",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Sito",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Podstawa zasypu",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Zasobnik tabletek",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Pokrywa zasypowa",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Zasobnik tabletek",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Pokrywa zasypowa",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Pojemnik odpadów",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Sito odpadów",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Rozdzielacz tabletek",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Pokrywa sita",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Pokrywa Simtapa",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Mocowanie węży Simtapa (komplet)",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Węże Simtapa",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Simtap",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Szczotka układająca",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "simtap"
            },
            {
                name: "Szczotki",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Trzpień mocujący wibracje",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Wibracja",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Prowadnice sita",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Sito",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Podstawa zasypu",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Zasobnik tabletek",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Pokrywa zasypowa",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Pojemnik odpadów",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Sito odpadów",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Pokrywa sita",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Rozdzielacz tabletek",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Węże podajnika",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Mocowanie węży Podajnika (komplet)",
                category: "ZASYP TABLETEK",
                machine: "BLISTERING MB421 34094 2004",
                label: "szczotkowy"
            },
            {
                name: "Łapka magazynka",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Talerzyki magazynków",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Bandy prowadzące",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Banda popychacza",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Popychacz",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Kontrpopychacz",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Ramiona ssące",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Blaszka prowadzenia skrzydełek",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Zamykanie kartonika",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Mechanizm kierunku zamykania",
                category: "ELEMENTY FORMATOWE",
                machine: "CARTON C 2305 13306610 2022",
                label: null
            },
            {
                name: "Element odwracania",
                category: "ELEMENTY FORMATOWE",
                machine: "SELECTOR DWM 750 HP 736415/22",
                label: null
            },
            {
                name: "Popychacz pionowy",
                category: "ELEMENTY FORMATOWE",
                machine: "SELECTOR DWM 750 HP 736415/22",
                label: null
            },
            {
                name: "Popychacz poziomy",
                category: "ELEMENTY FORMATOWE",
                machine: "SELECTOR DWM 750 HP 736415/22",
                label: null
            },
            {
                name: "Bandy wyjściowe",
                category: "ELEMENTY FORMATOWE",
                machine: "SELECTOR DWM 750 HP 736415/22",
                label: null
            }
        ]



}
